import React, { Component } from "react";
import {
  WhiteSpace,
  List,
  Toast,
  Drawer,
  SearchBar,
  Radio,
} from "antd-mobile-v2";
import "./index.less";
import allUrl from "../../api/allUrl";
import { get } from "../../api/service/services";
import debounce from "lodash/debounce";
import sectionData from "../../api/service/secsstion";
const RadioItem = Radio.RadioItem;
//涉事单位组建封装
class RelatedComt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      innerValue: 0,
      data: [],
      fetching: false,
    };
    this.lastFetchId = 0;
    this.fetchUser = debounce(this.fetchUser, 700);
  }
  goBack = () => {
    window.history.go(-1);
  };
  onChange = (item) => {
    this.setState({
      innerValue: item.value,
    });
    this.DuplicateDubmit(item);
  };
  fetchUser = (value) => {
    if (value == "") {
      return;
    }
    this.lastFetchId += 1;
    const fetchId = this.lastFetchId;
    this.setState({ data: [], fetching: true });
    get(allUrl.register.getSelectOrg, {
      orgId: sectionData.get("qiOrgCode"),
      orgName: value,
    }).then((res) => {
      if (fetchId !== this.lastFetchId) {
        // for fetch callback order
        return;
      }
      if (res.success === true && res.code == 200) {
        let data = JSON.parse(res.data);
        const newData = data.map((user) => ({
          label: user.abbreviation,
          value: user.id,
          parentOrgId: user.parentOrgId ? user.parentOrgId : "",
          orgDet: user.orgDepth,
        }));
        this.setState({ data: newData, fetching: false });
      }
    });
  };
  // 用户是否重复提交
  DuplicateDubmit = (data) => {
    const { selectData } = this.props;
    get(
      allUrl.register.DuplicateDubmit,
      {
        applyUserCode: sectionData.get("acount")
          ? sectionData.get("acount")
          : "",
        complaintOrgCode: data.value,
        acceptCode:sectionData.get("qiOrgCode"),
      },
      {
        "Content-Type": "application/json;charset=UTF-8",
      }
    )
      .then((res) => {
        if (res.success === true && res.code == 200) {
          if (res.data == false) {
            Toast.fail("您好，同一涉事单位一天只能提交一次，不可重复提交!", 3);
            return;
          }
          document.body.style.overflow = "";
          selectData(data);
        } else {
          Toast.fail(res.msg, 1);
        }
      })
      .catch((error) => {
        Toast.fail("接口异常", 1);
      });
  };
  render() {
    const { innerValue, data } = this.state;
    const { drawonCancel } = this.props;
    return (
      <div className="RelatedComt-wrap">
        <div
          className="relare-close"
          onClick={() => {
            drawonCancel();
            document.body.style.overflow = "";
          }}
        >
          x
        </div>
        <div className="header-cont">
          <SearchBar
            placeholder={this.props.placeholder}
            maxLength={20}
            onChange={this.fetchUser}
            onCancel={() => {
              document.body.style.overflow = "";
              drawonCancel();
            }}
          />
        </div>
        <List style={{ flex: "1", overflow: "auto" }}>
          {data.length > 0 ? (
            data.map((i) => (
              <RadioItem
                key={i.value}
                checked={innerValue == i.value}
                onChange={() => this.onChange(i)}
              >
                {i.label}
              </RadioItem>
            ))
          ) : (
            <div className="null-cont">暂无数据</div>
          )}
        </List>
      </div>
    );
  }
}
export default RelatedComt;
